import Markdown from 'react-markdown';
import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { theme } from '../../../../common/ui/theme';

const ReasoningContainer = styled.div`
    background-color: ${theme.colors.background.subtle};
    padding: ${theme.space[16]};
    border-radius: 6px;

    h1 {
        font-size: 22px;
        font-weight: ${theme.fontWeights[700]};
        line-height: 32px;
        margin-bottom: ${theme.space[24]};
    }

    h2 {
        font-size: 18px;
        font-weight: ${theme.fontWeights[600]};
        line-height: 24px;
        margin-top: ${theme.space[24]};
        margin-bottom: ${theme.space[8]};
    }

    h3 {
        font-size: 18px;
        line-height: 24px;
        font-weight: ${theme.fontWeights[400]};
    }

    p {
        font-size: 16px;
        font-weight: ${theme.fontWeights[400]};
        line-height: 24px;
        margin-top: ${theme.space[8]};
        margin-bottom: 0;
    }

    strong {
        font-weight: ${theme.fontWeights[700]};
    }

    ul {
        padding-left: ${theme.space[24]};
    }
`;

interface IntelligenceReasoningProps {
    markdownReasoning?: string;
    textReasoning?: string;
}

export const IntelligenceReasoning = ({ markdownReasoning, textReasoning }: IntelligenceReasoningProps) => {
    if (markdownReasoning) {
        return (
            <ReasoningContainer>
                <Markdown>{markdownReasoning}</Markdown>
            </ReasoningContainer>
        );
    }

    if (textReasoning) {
        return (
            <ReasoningContainer>
                <Text variant="body">{textReasoning}</Text>
            </ReasoningContainer>
        );
    }

    return null;
};
